(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.LanceTierPricing = api;
  if (root && root.document) api.install(root.document);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var EXPECTED = [
    { min: 1, discount_pct: 0 },
    { min: 2, discount_pct: 5 },
    { min: 6, discount_pct: 10 },
    { min: 12, discount_pct: 12 },
    { min: 24, discount_pct: 15 },
  ];
  var initialized = typeof WeakSet === 'function' ? new WeakSet() : null;

  function normalizeQuantity(value) {
    var quantity = Number(value);
    return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1;
  }

  function parseCanonicalSchedule(raw) {
    var value = raw;
    if (typeof value === 'string') {
      try { value = JSON.parse(value); } catch (error) { return null; }
    }
    if (!Array.isArray(value) || value.length !== EXPECTED.length) return null;
    var normalized = [];
    for (var i = 0; i < EXPECTED.length; i += 1) {
      var row = value[i];
      var expected = EXPECTED[i];
      if (!row || typeof row !== 'object' || Array.isArray(row)) return null;
      var keys = Object.keys(row);
      if (keys.some(function (key) { return !['min', 'discount_pct', 'label'].includes(key); })) return null;
      if (!Number.isSafeInteger(row.min) || row.min !== expected.min) return null;
      if (typeof row.discount_pct !== 'number' || row.discount_pct !== expected.discount_pct) return null;
      if (row.label != null && typeof row.label !== 'string') return null;
      var normalizedRow = { min: row.min, discount_pct: row.discount_pct };
      if (row.label) normalizedRow.label = row.label;
      normalized.push(normalizedRow);
    }
    return normalized;
  }

  function activeTier(schedule, quantity) {
    if (!Array.isArray(schedule) || !Number.isSafeInteger(quantity) || quantity < 1) return null;
    var active = null;
    for (var i = 0; i < schedule.length; i += 1) {
      if (quantity >= schedule[i].min) active = schedule[i];
      else break;
    }
    return active;
  }

  function unitPriceCents(baseCents, discountPct) {
    if (!Number.isSafeInteger(baseCents) || baseCents < 1) return null;
    if (typeof discountPct !== 'number' || !Number.isFinite(discountPct) || discountPct < 0 || discountPct > 100) return null;
    var scaledPct = Math.round(discountPct * 10000);
    var discountCents = Math.floor((baseCents * scaledPct) / 1000000);
    return baseCents - discountCents;
  }

  function priceForQuantity(schedule, quantity, baseCents) {
    var tier = activeTier(schedule, quantity);
    if (!tier) return null;
    var unitCents = unitPriceCents(baseCents, tier.discount_pct);
    if (unitCents == null) return null;
    return { tier: tier, unitCents: unitCents, lineCents: unitCents * quantity };
  }

  function rebindPrice(state, variant) {
    if (!state || !variant) return null;
    var cents = Number(variant.priceCents != null ? variant.priceCents : variant.price);
    if (!Number.isSafeInteger(cents) || cents < 1) return null;
    return { schedule: state.schedule, baseCents: cents, variantId: String(variant.id) };
  }

  function formatMoney(cents, currency) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}');
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);
  }

  function failClosedVariant(pdp, container, math, variant) {
    container.hidden = true;
    if (math) math.hidden = true;
    var basePrice = variant && typeof variant.priceFormatted === 'string'
      ? variant.priceFormatted
      : (variant && typeof variant.price === 'string' ? variant.price : null);
    if (basePrice && pdp && typeof pdp.querySelectorAll === 'function') {
      ['[data-price]', '[data-price-btn]', '[data-price-bar]'].forEach(function (selector) {
        pdp.querySelectorAll(selector).forEach(function (el) { el.textContent = basePrice; });
      });
    }
    return false;
  }

  function init(pdp) {
    if (!pdp || (initialized && initialized.has(pdp))) return false;
    var container = pdp.querySelector('[data-lance-tier-pricing]');
    var scheduleEl = pdp.querySelector('[data-lance-tier-schedule]');
    var variantsEl = pdp.querySelector('[data-variants]');
    var qtyInput = pdp.querySelector('[data-tier-quantity]');
    if (!container || !scheduleEl || !variantsEl || !qtyInput) return false;

    var schedule = parseCanonicalSchedule(scheduleEl.textContent);
    var eligible = Boolean(schedule);
    // Missing or unrecognized offer data must never disable quantity controls
    // or manufacture a discount. Keep base-price arithmetic available.
    if (!schedule) schedule = [{ min: 1, discount_pct: 0 }];
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (error) { variants = []; }
    if (!Array.isArray(variants) || !variants.length) {
      container.hidden = true;
      return false;
    }

    var currentId = String(container.dataset.currentVariantId || variants[0].id);
    var currentVariant = variants.find(function (variant) { return String(variant.id) === currentId; }) || variants[0];
    var state = rebindPrice({ schedule: schedule }, currentVariant);
    if (!state) {
      container.hidden = true;
      return false;
    }

    var table = container.querySelector('[data-tier-table]');
    var math = pdp.querySelector('[data-tier-math]');
    var currency = container.dataset.currency || 'USD';
    try {
      var initialQuantity = new URL(window.location.href).searchParams.get('quantity');
      if (initialQuantity !== null) qtyInput.value = String(normalizeQuantity(initialQuantity));
    } catch (error) { /* Quantity remains usable if URL access is unavailable. */ }

    function renderRows() {
      table.textContent = '';
      if (!eligible) return;
      schedule.forEach(function (tier) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tier-pricing__tier';
        button.dataset.min = String(tier.min);
        button.setAttribute('role', 'option');
        var qty = document.createElement('span');
        qty.className = 'tier-pricing__qty';
        qty.textContent = tier.min === 1 ? '1' : tier.min + '+';
        var price = document.createElement('span');
        price.className = 'tier-pricing__price';
        price.textContent = formatMoney(unitPriceCents(state.baseCents, tier.discount_pct), currency) + ' / ea';
        var save = document.createElement('span');
        save.className = 'tier-pricing__save';
        save.textContent = tier.discount_pct ? 'Save ' + tier.discount_pct + '%' : 'Base price';
        button.append(qty, price, save);
        if (tier.label) {
          var label = document.createElement('span');
          label.className = 'tier-pricing__label';
          label.textContent = tier.label;
          button.append(label);
        }
        table.append(button);
      });
    }

    function setPrice(selector, value) {
      pdp.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
    }

    function update(event) {
      var editing = event && event.type === 'input';
      var enteredQuantity = Number(qtyInput.value);
      // Leave incomplete edits alone so deleting "1" and typing "2" cannot
      // reinsert the minimum and turn the shopper's intended quantity into 12.
      if (editing && (!Number.isSafeInteger(enteredQuantity) || enteredQuantity < 1)) return;
      var quantity = normalizeQuantity(qtyInput.value);
      if (!editing && String(quantity) !== qtyInput.value) qtyInput.value = String(quantity);
      var result = priceForQuantity(schedule, quantity, state.baseCents);
      if (!result) return;
      table.querySelectorAll('.tier-pricing__tier').forEach(function (row) {
        var selected = Number(row.dataset.min) === result.tier.min;
        row.classList.toggle('active', selected);
        row.setAttribute('aria-selected', String(selected));
      });
      var unit = formatMoney(result.unitCents, currency);
      var total = formatMoney(result.lineCents, currency);
      setPrice('[data-price]', unit);
      setPrice('[data-price-btn]', total);
      setPrice('[data-price-bar]', total);
      setPrice('[data-quantity-bar]', quantity + (quantity === 1 ? ' item · total' : ' items · total'));
      setPrice('[data-tier-unit-price]', unit);
      setPrice('[data-tier-line-total]', total);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('quantity', String(quantity));
        window.history.replaceState(window.history.state, '', url);
      } catch (error) { /* Do not block buying if history is unavailable. */ }
    }

    renderRows();
    container.hidden = !eligible;
    if (math) math.hidden = false;
    update();

    container.addEventListener('click', function (event) {
      var row = event.target.closest('.tier-pricing__tier');
      if (!row) return;
      qtyInput.value = row.dataset.min;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('blur', update);
    pdp.querySelectorAll('[data-qty-delta]').forEach(function (button) {
      button.addEventListener('click', function () {
        qtyInput.value = String(Math.max(1, normalizeQuantity(qtyInput.value) + Number(button.dataset.qtyDelta)));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    pdp.addEventListener('lance:variant-changed', function (event) {
      var variant = event.detail && event.detail.variant;
      var rebound = rebindPrice(state, variant);
      if (!rebound) {
        failClosedVariant(pdp, container, math, variant);
        return;
      }
      state = rebound;
      container.hidden = !eligible;
      if (math) math.hidden = false;
      renderRows();
      update();
    });
    if (initialized) initialized.add(pdp);
    return true;
  }

  function install(doc) {
    function initAll(root) {
      root.querySelectorAll('lance-pdp').forEach(init);
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(doc); }, { once: true });
    else initAll(doc);
    doc.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  }

  return {
    EXPECTED: EXPECTED,
    activeTier: activeTier,
    failClosedVariant: failClosedVariant,
    init: init,
    install: install,
    normalizeQuantity: normalizeQuantity,
    parseCanonicalSchedule: parseCanonicalSchedule,
    priceForQuantity: priceForQuantity,
    rebindPrice: rebindPrice,
    unitPriceCents: unitPriceCents,
  };
});
